// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__AFfv1","addBtnContainer":"AddDetails_addBtnContainer__D7zin"};